module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0110.jpg?v=614318bd";